import { FormStore } from '@estee/elc-form';
import { RampFormValidator } from '../../controllers/common/RampFormValidator';

//TODO: APACFTRS1-770 to consolidate together with IStoreData
export interface IOnlineUser {
    [key: string]: string | number | boolean | undefined;
    pcEmailAddress: string;
    password: string;
}

export class OnlineSignUpFormStore extends FormStore<IOnlineUser> {
    constructor() {
        super({
            initialValues: {
                pcEmailAddress: '',
                password: ''
            },
            formValidator: new RampFormValidator()
        });
    }
}
